import { Button, Rate, Typography } from "antd";
import styled, { keyframes } from "styled-components";

const { Text, Title } = Typography;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Header = styled.div`
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1.5px solid #FDF0F4;
`;

export const AverageRate = styled(Title)`
  &.ant-typography {
    font-size: 2.4em;
    margin: 0;
    color: #1e293b;
    line-height: 1;
  }
`;

export const AverageStars = styled(Rate)`
  &.ant-rate {
    font-size: 18px;
    margin: 6px 0;
  }
`;

export const ReviewCount = styled(Text)`
  &.ant-typography {
    color: #94a3b8;
    font-size: 13px;
  }
`;

export const ReviewList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const ReviewCard = styled.div<{ $index?: number }>`
  padding: 16px 0;
  border-bottom: 1px solid #f1f5f9;
  animation: ${fadeIn} 0.3s ease-out forwards;
  animation-delay: ${(p) => (p.$index ?? 0) * 0.05}s;
  opacity: 0;

  &:last-child {
    border-bottom: none;
  }
`;

export const ReviewStars = styled(Rate)`
  &.ant-rate {
    font-size: 13px;
  }
`;

export const ReviewDate = styled(Text)`
  &.ant-typography {
    color: #94a3b8;
    font-size: 12px;
    margin-left: 8px;
  }
`;

export const ReviewComment = styled(Text)`
  &.ant-typography {
    display: block;
    margin-top: 6px;
    color: #475569;
    font-size: 14px;
    line-height: 1.6;
  }
`;

export const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #94a3b8;
`;

export const EmptyIcon = styled.div`
  font-size: 40px;
  margin-bottom: 12px;
  opacity: 0.4;
`;

export const LoadMoreWrapper = styled.div`
  padding: 16px 0;
`;

export const LoadMoreButton = styled(Button)`
  &.ant-btn {
    border-radius: 14px;
    height: 42px;
    font-weight: 600;
    background: linear-gradient(135deg, #D81B60 0%, #FF7F6B 100%);
    border: none;
    box-shadow: 0 4px 12px rgba(216, 27, 96, 0.3);

    &:hover,
    &:focus {
      background: linear-gradient(135deg, #B0124A 0%, #E64A5E 100%) !important;
      border: none !important;
      box-shadow: 0 4px 16px rgba(216, 27, 96, 0.4);
    }

    &:active {
      background: linear-gradient(135deg, #8A0E3A 0%, #C21E56 100%) !important;
      border: none !important;
    }

    > .ant-wave {
      display: none;
    }
  }
`;

export default {
  Header,
  AverageRate,
  AverageStars,
  ReviewCount,
  ReviewList,
  ReviewCard,
  ReviewStars,
  ReviewDate,
  ReviewComment,
  EmptyWrapper,
  EmptyIcon,
  LoadMoreWrapper,
  LoadMoreButton,
};
